import createIcon from "components/elements/Icons/create-icon";

export default createIcon(
  "ChevronDown",
  [
    [
      "path",
      {
        d: "M10.95 19.08c0.59 0.59 1.54 0.59 2.12 0l9 -9c0.59 -0.59 0.59 -1.54 0 -2.12s-1.54 -0.59 -2.12 0L12 15.88L4.06 7.94c-0.59 -0.59 -1.54 -0.59 -2.12 0s-0.59 1.54 0 2.12l9 9z",
      },
    ],
  ],
  "currentColor"
);
